import * as React from 'react'

const Warning = ({ className = 'svg-white' }: { className?: string }) => (
  <svg className={className} width='16' height='14' viewBox='0 0 16 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fill='none'
      d='M15.8157 12.25L8.76325 0.477273C8.39369 -0.159091 7.59297 -0.159091 7.22341 0.477273L0.170967 12.25C-0.260187 12.9818 0.170967 14 0.940884 14H15.0458C15.8157 14 16.2776 12.9818 15.8157 12.25ZM7.99368 11.4542C7.47014 11.4542 7.06978 11.0406 7.06978 10.4997C7.06978 9.95878 7.47014 9.54514 7.99368 9.54514C8.51723 9.54514 8.91759 9.95878 8.91759 10.4997C8.91759 11.0406 8.51723 11.4542 7.99368 11.4542ZM8.91759 8.59091C8.91759 8.78182 8.7944 8.90909 8.60962 8.90909H7.37775C7.19297 8.90909 7.06978 8.78182 7.06978 8.59091V4.45455C7.06978 4.26364 7.19297 4.13636 7.37775 4.13636H8.60962C8.7944 4.13636 8.91759 4.26364 8.91759 4.45455V8.59091Z'
    />
  </svg>
)

export default Warning



// WEBPACK FOOTER //
// ./src/components/icons/auth/Warning.tsx